/**
 * User API
 * Used for: - Manage User 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Access from './Access';


class UserEdit {
    
    constructor(email) { 
        
        UserEdit.initialize(this, email);
    }

    
    static initialize(obj, email) { 
        obj['email'] = email;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserEdit();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phone')) {
                obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
            }
            if (data.hasOwnProperty('firstName')) {
                obj['firstName'] = ApiClient.convertToType(data['firstName'], 'String');
            }
            if (data.hasOwnProperty('lastName')) {
                obj['lastName'] = ApiClient.convertToType(data['lastName'], 'String');
            }
            if (data.hasOwnProperty('profilePicture')) {
                obj['profilePicture'] = ApiClient.convertToType(data['profilePicture'], 'String');
            }
            if (data.hasOwnProperty('access')) {
                obj['access'] = Access.constructFromObject(data['access']);
            }
        }
        return obj;
    }


}


UserEdit.prototype['email'] = undefined;


UserEdit.prototype['phone'] = undefined;


UserEdit.prototype['firstName'] = undefined;


UserEdit.prototype['lastName'] = undefined;


UserEdit.prototype['profilePicture'] = undefined;


UserEdit.prototype['access'] = undefined;






export default UserEdit;

